export default {
  foodAllergy: "حساسیت غذایی",
  foodIntolerance: "عدم تحمل غذایی",
  eliminateFoods: "حذف مواد غذایی",
  typeOfOil: "نوع روغن",
  fastFoods: "مصرف فست فود",
  fastFoodsPeriodType: "مدت مصرف فست فود",
  carbonatedBeverage: "نوشیدنی گازدار",
  carbonatedPeriodType: "مدت مصرف نوشیدنی گازدار",
  caffeinatedBeverage: "نوشیدنی کافئین دار",
  caffeinatedPeriodType: "مدت مصرف نوشیدنی کافئین دار",
  junkFood: "غذاهای مضر",
  junkFoodPeriodType: "مدت مصرف غذای مضر",
  otherHabits: "عادات غذایی دیگر",
};
